import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { isPaidAccess, planLabel } from "@/lib/plan";
import { Button } from "@/components/ui/button";

export function SidebarPlanCard({ onNavigate }: { onNavigate?: () => void }) {
  const { user, currentStore } = useAuth();
  if (!user) return null;

  const showUpgrade =
    currentStore?.isOwner && !isPaidAccess(user) && user.plan !== "custom";

  return (
    <div className="rounded-[1.25rem] border border-border bg-card p-3.5">
      <div className="mb-3 flex items-center gap-3">
        <div className="relative flex h-11 w-11 shrink-0 items-center justify-center">
          <svg viewBox="0 0 36 36" className="h-11 w-11 -rotate-90">
            <circle
              cx="18"
              cy="18"
              r="15"
              fill="none"
              className="text-border"
              stroke="currentColor"
              strokeWidth="3"
            />
            <circle
              cx="18"
              cy="18"
              r="15"
              fill="none"
              className="text-primary"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeDasharray={`${showUpgrade ? 39.6 : 94.2} 94.2`}
            />
          </svg>
          <span className="absolute text-[9px] font-bold text-primary">
            {showUpgrade ? "Free" : "Pro"}
          </span>
        </div>
        <div className="min-w-0">
          <p className="text-[13px] font-semibold leading-tight">
            {planLabel(user.plan)} plan
          </p>
          <p className="mt-0.5 text-[11px] font-medium text-muted-foreground">
            {showUpgrade ? "Unlock analytics & more" : "You're on Premium"}
          </p>
        </div>
      </div>
      {showUpgrade ? (
        <Button
          asChild
          size="sm"
          className="h-9 w-full rounded-full font-semibold shadow-none"
        >
          <Link to="/dashboard/settings#billing" onClick={onNavigate}>
            Upgrade
          </Link>
        </Button>
      ) : (
        <Button
          asChild
          variant="outline"
          size="sm"
          className="h-9 w-full rounded-full border-border font-semibold shadow-none"
        >
          <Link to="/dashboard/settings#billing" onClick={onNavigate}>
            Manage plan
          </Link>
        </Button>
      )}
    </div>
  );
}
